export default {
    initLabelForDatePicker(labelParams) {
        let datePicker = !!labelParams ? document.getElementById(labelParams.id) :
                document.getElementById('datePicker');
        if (!!datePicker) {
            let datePickerLabel = document.createElement('label');
            datePickerLabel.innerHTML = !!labelParams ? labelParams.label
                    : 'Дата рождения';

            datePicker.parentNode.insertBefore(datePickerLabel, datePicker.nextSibling);
        }
    },

    initLabelForTimePicker(labelParams) {
        let timePicker = !!labelParams ? document.getElementById(labelParams.id) :
                document.getElementById('timePicker');
        if (!!timePicker) {
            let timePickerLabel = document.createElement('label');
            timePickerLabel.innerHTML = !!labelParams ? labelParams.label :
                    'Время рождения';

            timePicker.parentNode.insertBefore(timePickerLabel, timePicker.nextSibling);
        }
    }
}